// Voegt identieke API-reads samen: een lopende request wordt gedeeld en een
// geslaagd resultaat blijft `ttl` ms bruikbaar. Iedere aanroeper krijgt een
// eigen kopie, omdat stores responses muteren (bijv. cart-arrays).

const inflight = new Map();
const cache = new Map();

function clone(value) {
    return value === undefined ? value : JSON.parse(JSON.stringify(value));
}

// Telt API-requests die echt over de lijn gaan, zodat niet-dringend werk kan
// wachten tot de eerste reeks klaar is (zie utilities/defer.js).
let activeRequests = 0;
let settledWaiters = [];

export function trackRequest(promise) {
    activeRequests++;
    const done = () => {
        activeRequests--;
        if (activeRequests === 0) {
            const waiters = settledWaiters;
            settledWaiters = [];
            waiters.forEach((resolve) => resolve());
        }
    };
    promise.then(done, done);
    return promise;
}

export function whenRequestsSettled() {
    return activeRequests === 0
        ? Promise.resolve()
        : new Promise((resolve) => settledWaiters.push(resolve));
}

export function cachedRequest(key, request, ttl = 0) {
    const hit = cache.get(key);
    if (hit && hit.expires > Date.now()) {
        return Promise.resolve(clone(hit.value));
    }
    cache.delete(key);

    let pending = inflight.get(key);
    if (!pending) {
        pending = trackRequest(request()).then((value) => {
            if (inflight.get(key) === pending) {
                inflight.delete(key);
                // Geen fouten of lege antwoorden bewaren.
                if (ttl > 0 && value !== undefined && value !== null) {
                    cache.set(key, { value: clone(value), expires: Date.now() + ttl });
                }
            }
            return value;
        }, (error) => {
            if (inflight.get(key) === pending) inflight.delete(key);
            throw error;
        });
        inflight.set(key, pending);
    }
    return pending.then(clone);
}

// Verwijdert gecachte en lopende reads waarvan de key matcht (regex of
// functie), zodat een read na een schrijfactie de nieuwe serverstand ophaalt.
export function invalidateCachedRequests(pattern) {
    const matches = (key) => !pattern
        || (typeof pattern === 'function' ? pattern(key) : pattern.test(key));
    [...cache.keys()].filter(matches).forEach((key) => cache.delete(key));
    [...inflight.keys()].filter(matches).forEach((key) => inflight.delete(key));
}
